import React from "react";
import Headers from "../components/Header";
import Footer from "../Screen/Footer";

const TermsandCondition = () => {
  return (
    <div>
      <Headers />
      <section className="container">
        <h2 className="mb-3">Terms & Conditions</h2>
        <h3 className="mb-3">Introduction</h3>
        <p>
          These Terms and Conditions ("Terms") govern your access to and use of
          the website https://blaccdot.ae (hereinafter referred to as the
          "Platform"), owned and operated by Blaccdot (hereinafter referred to
          as "Blaccdot", "Platform Owner", "we", "us", "our").
        </p>
        <p>
          Blaccdot operates as a real estate lead generation service in the
          United Arab Emirates, connecting prospective property buyers, sellers,
          tenants, and investors with licensed real estate brokers, developers,
          and agencies operating in the UAE.
        </p>
        <p>
          By accessing, browsing, or otherwise using this Platform, you confirm
          that you have read, understood, and agree to be bound by these Terms
          and our Privacy Policy. If you do not agree to these Terms, please do
          not use or access the Platform.
        </p>
        <p>
          These Terms constitute a legally binding agreement between you and
          Blaccdot under the laws of the United Arab Emirates.
        </p>
        <h3 className="mb-3">Eligibility</h3>
        <p>
          By using this Platform, you represent and warrant that you are at
          least 18 years of age and have the legal capacity to enter into a
          binding agreement under UAE law. If you are accessing the Platform on
          behalf of a company or legal entity, you represent that you have the
          authority to bind that entity to these Terms.
        </p>
        <p>
          This Platform is intended for use by individuals and entities located
          in or interested in real estate opportunities within the United Arab
          Emirates. Blaccdot does not offer services outside the UAE through
          this Platform.
        </p>

        <h3 className="mb-3">Nature of Service</h3>
        <p>
          Blaccdot is a real estate lead generation platform. Our role is
          limited to:
        </p>
        <p>
          Collecting your property enquiry and preference information. Matching
          your enquiry with relevant licensed real estate brokers, developers,
          and agencies in the UAE. Facilitating the initial introduction between
          you and those real estate professionals.
        </p>
        <p>
          Blaccdot is not a licensed real estate broker or agency. We do not
          list, sell, rent, or manage properties directly. We do not represent
          either buyers or sellers in any real estate transaction. Any
          transaction, negotiation, or agreement you enter into with a real
          estate partner introduced through our Platform is solely between you
          and that partner.
        </p>
        <p>
          All real estate brokers and agencies we work with are required to hold
          valid licences issued by the relevant UAE regulatory authority,
          including the{" "}
          <span style={{ fontWeight: "bold" }}>
            Real Estate Regulatory Agency (RERA)
          </span>{" "}
          and the{" "}
          <span style={{ fontWeight: "bold" }}>
            {" "}
            Dubai Land Department (DLD)
          </span>{" "}
          where applicable.
        </p>
        <h3 className="mb-3">User Obligations</h3>
        <p>By using the Platform, you agree to the following:</p>
        <p>
          You will provide true, accurate, complete, and current information
          when submitting any enquiry or registering on the Platform. You will
          not submit false, misleading, or fraudulent enquiries. You will not
          use the Platform for any purpose that is unlawful, harmful, or
          prohibited under UAE law or these Terms. You will not attempt to gain
          unauthorised access to any part of the Platform or its related
          systems. You will not use the Platform to scrape, harvest, or collect
          data about other users or real estate partners without authorisation.
          You will not use the Platform to transmit spam, unsolicited
          communications, or malicious content. You will independently verify
          all information provided by real estate partners introduced through
          the Platform before entering into any transaction or agreement. You
          are solely responsible for all activity carried out through your
          account or enquiry submissions on the Platform.
        </p>

        <h3 className="mb-3">No Warranty on Real Estate Information</h3>
        <p>
          Blaccdot acts solely as an intermediary to connect you with real
          estate professionals. We do not verify, endorse, or guarantee the
          accuracy, completeness, legality, or suitability of any property
          information, listings, pricing, availability, or representations made
          by our real estate partners.
        </p>
        <p>
          You acknowledge that property information shared by real estate
          partners may change without notice and may contain inaccuracies. You
          are solely responsible for independently verifying all information
          before making any property-related decision. Blaccdot expressly
          excludes liability for any inaccuracies or errors in property
          information to the fullest extent permitted by UAE law.
        </p>

        <h3 className="mb-3">Third Party Real Estate Partners</h3>
        <p>
          By submitting an enquiry on the Platform, you consent to your contact
          details and property preferences being shared with relevant licensed
          real estate brokers, developers, and agencies in the UAE. These third
          parties are independent of Blaccdot and operate under their own terms
          and conditions and privacy policies.
        </p>
        <p>
          Blaccdot is not responsible for the conduct, advice, representations,
          or actions of any real estate partner introduced through the Platform.
          Any dispute arising from your dealings with a real estate partner must
          be resolved directly with that partner and, where applicable, through
          the relevant UAE regulatory authority such as RERA or DLD.
        </p>
        <p>
          We encourage you to conduct your own due diligence on any real estate
          professional before engaging their services.
        </p>

        <h3 className="mb-3">Intellectual Property</h3>
        <p>
          All content on the Platform including but not limited to its design,
          layout, graphics, text, logos, and software is the proprietary
          property of Blaccdot or its licensors and is protected under
          applicable UAE intellectual property laws.
        </p>
        <p>
          You are granted a limited, non-exclusive, non-transferable licence to
          access and use the Platform solely for the purpose of submitting
          genuine real estate enquiries. You may not reproduce, distribute,
          modify, create derivative works from, or commercially exploit any
          content on the Platform without our prior written consent.
        </p>
        <p>
          Unauthorised use of the Platform or its content may result in legal
          action under applicable UAE law.
        </p>

        <h3 className="mb-3">Fees and Charges</h3>
        <p>
          Blaccdot's lead generation and enquiry submission service is provided
          to users free of charge. You will not be charged any fee by Blaccdot
          for submitting a property enquiry or being introduced to a real estate
          partner.
        </p>
        <p>
          Any fees, commissions, or charges associated with real estate services
          provided by our partners are entirely between you and that partner and
          are governed by their own agreements.
        </p>

        <h3 className="mb-3">Limitation of Liability</h3>
        <p>
          To the fullest extent permitted by applicable UAE law, Blaccdot, its
          affiliates, officers, directors, employees, and agents shall not be
          liable for any direct, indirect, incidental, consequential, or
          punitive damages arising out of or in connection with your use of the
          Platform or reliance on any information provided through it.
        </p>
        <p>
          This includes but is not limited to any loss arising from your
          dealings with a real estate partner introduced through the Platform,
          any inaccuracy in property information, any failure or interruption of
          the Platform, or any unauthorised access to your data.
        </p>
        <p>
          Your use of the Platform and its services is entirely at your own
          risk.
        </p>

        <h3 className="mb-3">Indemnification</h3>
        <p>
          You agree to indemnify, defend, and hold harmless Blaccdot, its
          affiliates, group companies, and their respective officers, directors,
          employees, and agents from and against any claims, liabilities,
          damages, losses, penalties, or expenses (including reasonable legal
          fees) arising out of or in connection with your breach of these Terms,
          your violation of any applicable UAE law or regulation, or your
          infringement of any third party rights.
        </p>

        <h3 className="mb-3">Force Majeure</h3>
        <p>
          Blaccdot shall not be liable for any failure or delay in performing
          its obligations under these Terms where such failure or delay results
          from circumstances beyond our reasonable control, including but not
          limited to natural disasters, acts of government, war, civil unrest,
          telecommunications failures, or any other force majeure event.
        </p>
        <h3 className="mb-3">Modifications to the Platform and Terms</h3>
        <p>
          Blaccdot reserves the right to modify, suspend, or discontinue the
          Platform or any part of it at any time without prior notice. We also
          reserve the right to update or amend these Terms at any time. Updated
          Terms will be posted on the Platform with a revised effective date.
          Your continued use of the Platform following any update constitutes
          your acceptance of the revised Terms. It is your responsibility to
          review these Terms periodically.
        </p>

        <h3 className="mb-3">Privacy</h3>
        <p>
          Your use of the Platform is also governed by our Privacy Policy, which
          is incorporated into these Terms by reference and available at
          https://blaccdot.ae/privacy-policy. By using the Platform, you confirm
          that you have read and agreed to our Privacy Policy.
        </p>

        <h3 className="mb-3">Governing Law and Jurisdiction</h3>
        <p>
          These Terms and any dispute or claim arising out of or in connection
          with them, including their formation, validity, enforceability, or
          termination, shall be governed by and construed in accordance with the
          laws of the{" "}
          <span style={{ fontWeight: "bold" }}>United Arab Emirates.</span>
        </p>
        <p>
          Any disputes arising out of or in connection with these Terms shall be
          subject to the exclusive jurisdiction of the competent courts of the
          <span style={{ fontWeight: "bold" }}>UAE</span>, in the emirate where
          Blaccdot is registered. If you are operating within a UAE free zone
          such as DIFC or ADGM, the relevant free zone courts or arbitration
          centre may have jurisdiction as applicable.
        </p>
        <h3 className="mb-3">Severability</h3>
        <p>
          If any provision of these Terms is found to be invalid, unlawful, or
          unenforceable under applicable UAE law, that provision shall be
          modified to the minimum extent necessary to make it enforceable, or
          severed if modification is not possible, without affecting the
          validity and enforceability of the remaining provisions.
        </p>
        <h3 className="mb-3">Entire Agreement</h3>
        <p>
          These Terms, together with our Privacy Policy and any other policies
          published on the Platform, constitute the entire agreement between you
          and Blaccdot with respect to your use of the Platform and supersede
          all prior agreements, representations, or understandings.
        </p>

        <h3 className="mb-3">Contact Us</h3>
        <p>
          All concerns, queries, or communications relating to these Terms
          should be directed to:
        </p>
        <ul>
          <li>
            <span style={{ fontWeight: "bold" }}>Organisation:</span> Blaccdot
          </li>

          <li>
            <span style={{ fontWeight: "bold" }}>Email:</span>{" "}
            support@blaccdot.ae
          </li>
          <li>
            <span style={{ fontWeight: "bold" }}>Phone:</span> +971521912022
          </li>
          <li>
            <span style={{ fontWeight: "bold" }}>Operating Hours:</span> Monday
            to Friday, 9:00 AM – 6:00 PM (GST, UAE Time)
          </li>
          <li>
            <span style={{ fontWeight: "bold" }}>Mailing Address:</span>
            {/* Rakez Business Zone, Al Nakheel Area, P.O.Box No.10055, Ras Al
            Khaimah, United Arab Emirates */}
               Dubai, UAE
          </li>

          <li>
            <span style={{ fontWeight: "bold" }}>Website:</span>{" "}
            <a
              href="https://blaccdot.ae"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007bff", textDecoration: "underline" }}
            >
              https://blaccdot.ae
            </a>
          </li>
        </ul>
        <i className="pb-3">
          These Terms and Conditions are governed by the laws of the United Arab
          Emirates. Blaccdot operates as a real estate lead generation
          intermediary and does not hold a real estate brokerage licence. All
          real estate transactions facilitated through introductions made on
          this Platform are the sole responsibility of the transacting parties.
        </i>
      </section>

      <Footer />
    </div>
  );
};

export default TermsandCondition;
